import { useQuery } from '@tanstack/react-query';
import { NOTIFICATIONS_POLL_MS } from '@/lib/constants/notifications';
import { listNotifications } from '../api/notifications.api';
import { notificationsKeys } from './notifications.keys';

/**
 * Poll the caller's own entity's notifications (MYN-55) - no push channel
 * exists, so "real-time" here means low-latency polling. Pauses while the
 * tab is hidden to avoid needless load. `enabled` lets the caller gate
 * polling on entity type/permission without an extra wrapper.
 */
export function useNotificationsPoll(enabled: boolean) {
  return useQuery({
    queryKey: notificationsKeys.all,
    queryFn: listNotifications,
    enabled,
    refetchInterval: NOTIFICATIONS_POLL_MS,
    refetchIntervalInBackground: false,
  });
}
